module.exports = __webpack_public_path__ + "static/media/right_arrow_white.ee1075d6.svg";